import React, { useState } from "react";
import * as emailjs from 'emailjs-com'

const ContactForm = () => {
  const [ formData, setFormData ] = useState({
    full_name: "",
    email: "",
    subject: "",
    message: ""
  })
  const [ loading, setLoading ] = useState(false)

  const handleChange = ({target}) => {
    setFormData({
      ...formData,
      [target.name]: target.value
    })
  }

  const submit = async e => {
    e.preventDefault();
    setLoading(true);

    const { full_name, email, subject, message } = formData;

    let templateParams = {
      full_name,
      email,
      subject,
      message
     }

     const res = emailjs.send(
      'gmail',
      'template_pgbbfyo',
       templateParams,
      'user_HTmKaewztpPEtcwA6REIw'
     )

      res && setLoading(false);
  }

  return (
  <div className="col-xl-8 animate" data-animation="scaleAppear">
    <div className="ls ms pt-30 p-35">
      <h4 className="special-heading underline">Contact Form</h4>
      <p>For general inquiries, partnerships or press, please use the form below and we'll be in touch soon!</p>
      <div className="divider-40"></div>
      <form
        className="c-mb-20 c-gutter-20"
        onSubmit={submit}
      >

        <div className="row">
          <div className="col-sm-6">
            <div className="form-group has-placeholder">
              <label for="name">
                Full Name <span className="required">*</span>
              </label>
              <i className="fa fa-user"></i>
              <input
                type="text"
                aria-required="true"
                size="30"
                name="full_name"
                onChange={handleChange}
                id="name"
                className="form-control"
                placeholder="Full Name"
              />
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group has-placeholder">
              <label for="email">
                Email address<span className="required">*</span>
              </label>
              <i className="fa fa-envelope"></i>
              <input
                type="email"
                aria-required="true"
                size="30"
                name="email"
                onChange={handleChange}
                id="email"
                className="form-control"
                placeholder="Email"
              />
            </div>
          </div>
        </div>
        <div className="row">

          <div className="col-sm-6">
            <div className="form-group has-placeholder">
              <label for="topic">
                Subject<span className="required">*</span>
              </label>
              <i className="fa fa-tag"></i>
              <input
                type="text"
                aria-required="true"
                size="30"
                name="subject"
                onChange={handleChange}
                id="topic"
                className="form-control"
                placeholder="Subject"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 mb-0">
            <div className="form-group has-placeholder">
              <label for="message">Message</label>
              <i className="fa fa-comment"></i>
              <textarea
                aria-required="true"
                rows="6"
                cols="45"
                name="message"
                onChange={handleChange}
                id="message"
                className="form-control"
                placeholder="Message"
              ></textarea>
            </div>
          </div>
        </div>

        <div className="divider-60 d-none d-lg-block"></div>
        <div className="divider-30 hidden-above-lg"></div>

        <div className="row">
          <div className="col-sm-12 text-left">
            <div className="form-group d-flex align-items-start flex-column flex-md-row">
              <button
                type="submit"
                className="btn btn-maincolor btn-small"
                disabled={loading}
              >
                Send
              </button>
            </div>

            <div className="mb--5"></div>
          </div>
        </div>
      </form>
    </div>
  </div>
);}

export default ContactForm;
